import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatDatepickerModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatTabsModule,
} from '@angular/material';
import { ListingSearchComponent } from './listing-search/listing-search.component';
import { ListingComponent } from './listing/listing.component';
import { PaginatorComponent } from './paginator/paginator.component';

@NgModule({
  declarations: [
    ListingComponent,
    ListingSearchComponent,
    PaginatorComponent
  ],
  exports: [
    ListingComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTabsModule,
  ]
})
export class DashboardModule { }
